// Module
var code = "<div class=\"user-image <tpl if='userColor'>chat-userColor</tpl>\">\n    <div class=\"user-image-inner user-image-inner-{userIndex}\">\n        <div class=\"user-image-imgElement\">&nbsp;</div>\n    </div>\n    <tpl if=\"unread\"><div class=\"chat-unreadMsg-marker\"><span>{unread}</span></div></tpl>\n</div>\n";
// Exports
module.exports = code;